import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './components/App'

export let startAchievementManager = (
  badge_designs,
  badges,
  cert_designs,
  certificates
) => {
  ReactDOM.render(
    <App
      badgeDesigns={badge_designs}
      badges={badges}
      certDesigns={cert_designs}
      certificates={certificates}
    />,
    document.getElementById('achievementManagerApp')
  )
}
